import { Link } from "react-router-dom";
import logo from "@/assets/adnexa-logo.png";
import { useSettings } from "@/context/SettingsContext";

export default function Logo({ className = "", showText = true, size = "md", to = "/" }) {
  const { settings } = useSettings() || {};
  const src = settings?.logo ? settings.logo : logo;
  const dims = { sm: "h-8", md: "h-10", lg: "h-14" }[size] || "h-10";
  const inner = (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <img src={src} alt="ADNEXA DIGITAL" className={`${dims} w-auto object-contain drop-shadow-[0_0_10px_rgba(212,175,55,0.25)]`} />
      {showText && (
        <span className="font-display font-extrabold tracking-tight leading-none text-lg sm:text-xl">
          <span className="text-white">ADNEXA</span>{" "}
          <span className="gold-text">DIGITAL</span>
        </span>
      )}
    </span>
  );
  return to ? <Link to={to} className={className}>{inner}</Link> : <span className={className}>{inner}</span>;
}
